import React, { useState, useEffect } from 'react';
import api from '../config/api';
import './StockAlertsModal.css';

const StockAlertsModal = ({ onClose, onReplenish }) => {
  const [alerts, setAlerts] = useState({ outOfStock: [], lowStock: [], totalAlerts: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAlerts();
  }, []);

  const fetchAlerts = async () => {
    try {
      const response = await api.get('/admin/stock-alerts');
      setAlerts(response.data);
    } catch (error) {
      console.error('Failed to fetch stock alerts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleReplenish = async (productId, productName) => {
    const newStock = prompt(`Enter new stock quantity for "${productName}":`);
    if (newStock === null || newStock === '') return;
    
    const quantity = parseInt(newStock);
    if (isNaN(quantity) || quantity < 0) {
      alert('Please enter a valid number');
      return;
    }

    try {
      await api.put(`/admin/products/${productId}/stock`, { stock_quantity: quantity });
      alert('Stock updated successfully!');
      await fetchAlerts(); // Refresh alerts
      if (onReplenish) onReplenish();
    } catch (error) {
      alert('Failed to update stock');
    }
  };

  if (loading) {
    return (
      <div className="stock-alerts-overlay">
        <div className="stock-alerts-modal">
          <div className="loading">Loading alerts...</div>
        </div>
      </div>
    );
  }

  if (alerts.totalAlerts === 0) {
    return null; // Don't show modal if no alerts
  }

  return (
    <div className="stock-alerts-overlay" onClick={onClose}>
      <div className="stock-alerts-modal" onClick={(e) => e.stopPropagation()}>
        <div className="stock-alerts-header">
          <h2>⚠️ Stock Alerts</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="stock-alerts-content">
          {alerts.outOfStock.length > 0 && (
            <div className="alert-section out-of-stock">
              <h3>
                🔴 Out of Stock ({alerts.outOfStock.length})
              </h3>
              <ul className="alert-list">
                {alerts.outOfStock.map(product => (
                  <li key={product.id} className="alert-item">
                    <div className="alert-item-info">
                      <strong>{product.name}</strong>
                      {product.sku && <span className="sku">SKU: {product.sku}</span>}
                      <span className="stock-badge out">0 items</span>
                    </div>
                    <button 
                      className="btn-replenish"
                      onClick={() => handleReplenish(product.id, product.name)}
                    >
                      Replenish
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {alerts.lowStock.length > 0 && (
            <div className="alert-section low-stock">
              <h3>
                🟡 Low Stock ({alerts.lowStock.length})
              </h3>
              <ul className="alert-list">
                {alerts.lowStock.map(product => (
                  <li key={product.id} className="alert-item">
                    <div className="alert-item-info">
                      <strong>{product.name}</strong>
                      {product.sku && <span className="sku">SKU: {product.sku}</span>}
                      <span className="stock-badge low">{product.stock_quantity} items</span>
                    </div>
                    <button 
                      className="btn-replenish"
                      onClick={() => handleReplenish(product.id, product.name)}
                    >
                      Replenish
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div className="stock-alerts-footer">
          <button className="btn-primary" onClick={() => window.location.href = '/hair-wp/products'}>
            View All Products
          </button>
          <button className="btn-secondary" onClick={onClose}>
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
};

export default StockAlertsModal;


